import _ from 'lodash'

export const isPopupBlockerEnabled = (window) => {
  return _.isUndefined(window) || _.isNull(window)
}

export const hasAdBlock = () => _.isUndefined(global.hasAdBlock) || global.hasAdBlock
